angular.module('bmsApp.crm.customer').controller('CustomerIndexCtrl', function(
    $state,
    $scope,
    ngTableParams,
    EmailSvc,
    CustomerSvc,
    $cookies,
    InstanceSvc,
    $localStorage,
    $q,
    LicenseOptionsSvc) {

    $scope.loading = true;
    $scope.updating = true;
    $scope.ecomEnabled = InstanceSvc.instance.ecomEnabled();

    var promises = {
        licenseOptions: LicenseOptionsSvc.license(),
        licenceTypeOptions: LicenseOptionsSvc.network(),
    };
    $q.all(promises)
        .then(function (response) {
            $scope.licenseOptions = response.licenseOptions.data.options;
            $scope.licenseTypeOptions = response.licenceTypeOptions.data.options;
            $scope.loading = false;
        });

    $scope.statusOptions = [{
            value: 3,
            label: 'Active'
        },
        {
            value: 1,
            label: 'Pending'
        },
        {
            value: 2,
            label: 'Prospect'
        },
        {
            value: 4,
            label: 'Inactive'
        }
    ];

    $scope.optedInOptions = [{
            value: true,
            label: 'Opted In'
        },
        {
            value: false,
            label: 'Opted Out'
        },
    ];

    var defaultCustomerParams = function() {
        return {
            page: 1, // show first page
            count: $scope.config.table.params.count, // count per page
            sorting: {
                surname: 'asc' // initial sorting
            },
            filter: {
                search: '',
                status: [3, 1],
                optedInOnly: 0,
                withoutCleansed:true,
                licences: null,
                licenceType: null,
                // dateRange: {
                //     startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
                //     endDate: moment().format('YYYY-MM-DD')
                // },
            }
        };
    };

    let initialCustomerParams = function() {
        if (angular.isDefined($localStorage.customerIndexParams)) {
            return angular.extend({}, defaultCustomerParams(), $localStorage.customerIndexParams);
        } else {
            return angular.extend({}, defaultCustomerParams());
        }
    };

    let params = initialCustomerParams();

    // copy the filters to a workable state
    $scope.customerFilters = angular.copy(params.filter);

    $scope.tableParams = new ngTableParams(params, {
        total: 0, // length of data
        counts: $scope.config.table.settings.counts, // available page counts
        getData: function($defer, params) {
            $scope.updating = true;
            $localStorage.customerIndexParams = params.$params;
            CustomerSvc.index(params.$params)
                .then(function(response) {
                    params.total(response.data.customer_filtered_count);
                    $defer.resolve(response.data.customer_collection);
                    $scope.$emit('customerIndexUpdated', {
                        customer_collection: response.data.customer_collection,
                        customer_filtered_count: response.data.customer_filtered_count,
                        customer_total_count: response.data.customer_total_count
                    });
                    $scope.customer_filtered_count = response.data.customer_filtered_count;
                    $scope.customer_total_count = response.data.customer_total_count;

                    // Check if we've exceeded our page size, if we have, go back
                    if (response.data.customer_filtered_count > 0 && !response.data.customer_collection.length) {
                        let newParams = angular.copy($scope.tableParams.$params);
                        newParams.page--;
                        angular.extend($scope.tableParams.$params, newParams);
                    }
                    $scope.updating = false;
                    $scope.loading = false;
                });
        }
    });

    // Store the table params whenever anything changes
    $scope.$watch('tableParams.$params', function(value) {
        if (angular.isObject(value)) {
            $cookies.customerIndexParams = JSON.stringify(value);
        }
    }, true);

    // update text search without having to click apply
    $scope.filterChanged = function() {
        $scope.tableParams.$params.filter.search = $scope.customerFilters.search;
    };

    // other filters
    $scope.filterApply = function() {
        angular.extend($scope.tableParams.$params.filter, angular.copy($scope.customerFilters));
    };

    $scope.clearDateFilter = function() {
        $scope.customerFilters.dateRange = null
        $scope.filterApply();
    }

    $scope.filterReset = function() {
        angular.extend($scope.tableParams.$params, defaultCustomerParams());
        angular.extend($scope.customerFilters, defaultCustomerParams().filter);
    };

    $scope.rowClicked = function(customer) {
        $state.go('main.crm.customer.index.view', {
            customerId: customer.id
        });
    };

    $scope.$on('customerIndexExport', function() {
        var params = angular.copy($scope.tableParams.$params);

        // console.log(angular.copy(params));
        // angular.merge(params.filter, {
        // 	'optedInOnly': 1,
        // });

        CustomerSvc.export(params);
    });

    $scope.phonesContactTypeIds = [1, 2, 3]; // ignore fax

    $scope.phoneContactTypeComparator = function(actual, expected) {
        return expected.indexOf(actual) > -1;
    };

    $scope.viewOnMap = function(customer) {
        $state.go('main.crm.customer.index.mapSingle', {
            id: customer.id
        });
    };

    $scope.$on('customerIndexViewMap', function() {
        $state.go('main.crm.customer.index.mapMultiple', {
            params: $.param($scope.tableParams.$params.filter)
        });
    });

    $scope.emailForm = function(emailAddress, objectType, objectId, customer) {
        var email = {
            to: emailAddress,
            object_type: objectType,
            object_id: objectId
        };
        EmailSvc.showSendModal(email, customer);
    };

});
